import { render, staticRenderFns } from "./Slice.vue?vue&type=template&id=d220108c"
import script from "./Slice.vue?vue&type=script&lang=js"
export * from "./Slice.vue?vue&type=script&lang=js"
import style0 from "./Slice.vue?vue&type=style&index=0&id=d220108c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports